export const getProductCustomisation = state =>
  state.session.product.customisation;
